/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_MAIN_SETTINGS_OPTIONS_LIST = 'SET_MAIN_SETTINGS_OPTIONS_LIST';
export const SET_MAIN_SETTINGS_SELECTED_OPTION = 'SET_MAIN_SETTINGS_SELECTED_OPTION';
